/* eslint-disable react/jsx-curly-newline */
/* eslint-disable no-unused-expressions */
import React, { memo, useEffect, useMemo, useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Input, Label, Row, Button } from 'reactstrap';
import { updateEpikBox, updateSipPri, setCasFailoversList } from '../../../../../actions/EpikBoxes';
import {
  SELECTED_OPTIONS,
  SIP_IP_ADDRESS,
  SIP_IP_ADDRESS_WITHOUT_ONE,
  SIP_PORT,
} from './constants';
import addBoxAction from '../../../../../lib/api/addBoxAction';
import addNote from '../../../../../lib/api/addNote';
import Toggle from '../../../../Toggle';
import { toast } from 'react-toastify';
import AddSecurityCodeModal from '../../../../AddSecurityCodeModal';
import MultiSelectPriDropdown from '../../../../MultiSelectPriDropdown';
import useEpikBoxCas from './useEpikBoxCas';
import ConfirmationModal from '../../../../ConfirmationModal';
import SpinnerCircles from '../../../../Spinner/SpinerCircles';

export const EpikboxSip = memo(({ sipDetails, priSipStatus, setDcUpdatePopup }) => {
  const box = useSelector(state => state.AppState.boxDetails.box);
  const sipSettings = useSelector(state => state.AppState.priSipData?.sipSettingData);
  const [username, setUsername] = useState(sipSettings?.username || '');
  const [password, setPassword] = useState(sipSettings?.password || '');
  const [ipAddress, setIpAddress] = useState(sipSettings?.ip || '');
  const [selectedOptions, setSelectedOption] = useState(sipSettings?.authType || '');
  const [flag, setFlag] = useState(false);
  const [casToggle, setCasToggle] = useState(false);
  const [securityModal, setSecurityModal] = useState(false);
  const [numberOfChannel] = useState(24);
  const [bchannel, setBchannel] = useState('');
  const [channelRange, setchannelRange] = useState('');
  const [echoCancellation, setEchoCancellation] = useState(false);
  const [casCompaniesList, setCasCompaniesList] = useState([]);
  const [casFailovers, setCasFailovers] = useState([]);
  const [preSelectedCasList, setPreSelectedCasList] = useState([]);
  const [sortedCasList, setSortedCasList] = useState([]);
  const [defaultCas, setDefaultCas] = useState(false);
  const [warningModal, setWarningModal] = useState(false);
  const [saveLoading, setSaveLoading] = useState(false);
  const dispatch = useDispatch();
  const token = localStorage.getItem('jwtToken') || null;

  const companyCasBoxes = useSelector(state => state.UIState.companies.companySipBoxes);
  const casSettings = useSelector(state => state.AppState.priSipData?.sipSettingData);
  const { produceState, dropDownStates, handleDropDownStates } = useEpikBoxCas(
    numberOfChannel,
    bchannel,
    channelRange,
    echoCancellation,
    casFailovers,
    sortedCasList,
    defaultCas,
  );
  useEffect(() => {
    if (companyCasBoxes?.length > 0) {
      setCasCompaniesList(companyCasBoxes);
    }
  }, [companyCasBoxes]);

  const setPreSelectedList = (list) => {
    const preSelectedList = [];
    list?.forEach(item => {
      const found = companyCasBoxes?.find(box => box?._id === item);
      if (found) {
        preSelectedList.push(found);
      }
    });
    setPreSelectedCasList(preSelectedList);
  }

  useEffect(() => {
    if (casSettings && Object?.entries(casSettings).length) {
      setBchannel(casSettings?.bChannels || '');
      setEchoCancellation(casSettings?.echoCancellation || false);
      setCasFailovers(casSettings?.casFailovers || []);
      if (casSettings?.casFailovers?.length > 0) {
        setPreSelectedList(casSettings?.casFailovers);
        setCasToggle(true)
      }
    }
  }, [casSettings]);
  const onSecurityConfirm = () => {
    setCasToggle(!casToggle);
    setSecurityModal(false);
  }
  const sortedDataList = (data) => {
    setSortedCasList(data);
  }
  const onToggleCAS = (e) => {
    setCasToggle(!e);
  //   if (!e) {
  //     setSecurityModal(true);
  //   } else {
  //   setCasToggle(false); 
  // }
  }
  const onMouseOver = () => {
    setDefaultCas(false);
  };
  const onCasChange = async (list) => {
    await dispatch(setCasFailoversList(list));
    const listNumbers = list?.reduce((acc, curr) => {
      acc.push(curr._id);
      return acc;
    }, []);
    setCasFailovers(listNumbers);
  }

  const isAuthenticationIpAuth = useMemo(() => !!(selectedOptions === SELECTED_OPTIONS.IP_AUTH), [
    selectedOptions,
  ]);

  const onSubmit = async () => {
    setSaveLoading(true);
    try {
    // if (!ipAddress) return;
    // let ip = ipAddress;
    // switch (selectedOptions) {
    //   case SELECTED_OPTIONS.USERNAME_PASSWORD:
    //     ip = SIP_IP_ADDRESS;
    //     break;
    //   case SELECTED_OPTIONS.IP_AUTH:
    //     ip = SIP_IP_ADDRESS_WITHOUT_ONE.concat(ipAddress);
    //     break;
    //   default:
    //     break;
    // }

    // const body = { username, password, ipAddress: ip };


    // const sipNumberSettings = {
      // username: isAuthenticationIpAuth ? '' : username,
      // password: isAuthenticationIpAuth ? '' : password,
      // ip,
      // authType: selectedOptions.toLowerCase(),
    // };
    
    const ispri = false;
    const newState = produceState();
    const casSettingsUpdated = { ...casSettings, ...newState };
    const updatedFeature = { ...box?.features, pri: priSipStatus?.pri, sip: priSipStatus?.sip };
    let sipNumberSettings = {
      ...casSettingsUpdated,
      numberSettings: sipSettings?.numberSettings || [],
      casFailovers: casFailovers,
    };

    if (casToggle) {
      if (!casFailovers || casFailovers.length <= 0) {
        toast.error('Select at least one failover backup');
        setSaveLoading(false);
        return;
      }
    } else {
      sipNumberSettings = { ...sipNumberSettings, casFailovers: [] };
    }
    // const sipPriUpdate = await dispatch(updateSipPri(token, box?._id, ispri, sipNumberSettings)); // updating SipPri based on current authtype
    let sipPriResponse

        if (!flag) {
          await dispatch(
            updateEpikBox(token, {
              ...box,
              features: updatedFeature,
              sipSettings: sipNumberSettings,
            }),
          );
          sipPriResponse = await dispatch(updateSipPri(token, box?._id, ispri, sipNumberSettings));
        }

        if (sipPriResponse) {
          addBoxAction({ boxID: box?._id, activity: 'updated CAS details' });
          addNote({ boxID: box?._id, note: "CAS details updated"});
            }

    // sipDetails(token, body); // discuss it with haseem later since it is doing nothing

    //     await dispatch(
    //         updateEpikBox(token, {
    //             ...box,
    //             features: updatedFeature,
    //     sipSettings: sipNumberSettings,
    //   }),
    //     );
    setWarningModal(true);
    setPreSelectedCasList([])
    } finally {
      setSaveLoading(false);
    }
};

  useEffect(() => {
    setUsername(sipSettings?.username || '');
    setPassword(sipSettings?.password || '');
    setIpAddress(sipSettings?.ip || '');
    setSelectedOption(sipSettings?.authType || '');
  }, [sipSettings]);

  useEffect(() => {
    if (isAuthenticationIpAuth && sipSettings?.ip)
      setIpAddress(
        sipSettings?.ip.substring(sipSettings?.ip.lastIndexOf('.') + 1, sipSettings?.ip.length),
      );
  }, [selectedOptions, sipSettings]);

  const handleSelectedOption = useCallback(e => {
    const { value } = e.currentTarget;
    setSelectedOption(e.currentTarget.value);
    value === SELECTED_OPTIONS.USERNAME_PASSWORD ? setIpAddress(SIP_IP_ADDRESS) : setIpAddress('');
  }, []);

  const handleInputChnage = useCallback(e => {
    const { value } = e.target;
    if (value.length > 3) return;
    setIpAddress(value);
  }, []);

  const IpInfo = () => (
    <>
      <Row className="sip-input ">
        <Col sm={6} md={4}>
          <Label className="sip-input-label">IP Info</Label>
        </Col>
        <Col sm={6} md={5} className="center">
          <div className="center-vertically">
            <span>{SIP_IP_ADDRESS}</span>
            <span>{`Port: ${SIP_PORT}`}</span>
          </div>
        </Col>
      </Row>
    </>
  );

  return (
    <div className="priContainer">
      <p className="heading">CAS Settings</p>
      <div className="sip-section ">
        <Row className="sip-input ">
          <Col sm={6} md={4}>
            <Label for="name" className="sip-input-label">
              Number of Channels
            </Label>
          </Col>
          <Col sm={6} md={5}>
            <Input required value={dropDownStates.numberOfChannel} disabled type="text" name="numberOfChannel" />
          </Col>
        </Row>
      </div>
      <Row style={{ paddingTop: '5px' }}>
        <Col sm={6} md={4}>
          <Label className="sip-input-label">T1 Framing</Label>
        </Col>
        <Col sm={6} md={5}>
            <Input required value={dropDownStates.framing} disabled type="text" name="T1Framing" />
          </Col>
      </Row>
      <Row style={{ paddingTop: '5px' }}>
        <Col sm={6} md={4}>
          <Label className="sip-input-label">Line Code</Label>
        </Col>
        <Col sm={6} md={5}>
            <Input required value={dropDownStates.lineOfCode} disabled type="text" name="lineOfCode" />
        </Col>
      </Row>
      <Row style={{ paddingTop: '5px' }}>
        <Col sm={6} md={4}>
          <Label className="sip-input-label">Timing Source</Label>
        </Col>
        <Col sm={6} md={5}>
        <Input
            type="select"
            value={dropDownStates.timeAndSource}
            onChange={e => handleDropDownStates('timeAndSource', e.currentTarget.value)}
          >
            <option key="internal" value="internal">
              Internal
            </option>
            <option key="external" value="external">
              External
            </option>
          </Input>
        </Col>
      </Row>
      <div className="sip-section ">
        <Row className="sip-input ">
          <Col sm={6} md={4}>
            <Label for="name" className="sip-input-label">
              B Channel
            </Label>
          </Col>
          <Col sm={6} md={5}>
            <Input required value={dropDownStates.bChannel} disabled type="text" name="bChannel" />
        </Col>
        </Row>
      </div>
      <Row style={{ paddingTop: '5px' }}>
        <Col sm={6} md={4}>
          <Label className="sip-input-label">Switch Type</Label>
        </Col>
        <Col sm={6} md={5}>
          <Input
            type="select"
            value={dropDownStates.switchType}
            onChange={e => handleDropDownStates('switchType', e.currentTarget.value)}
          >
            <option key="national" value="national">
              national
            </option>
            <option key="ni2" value="ni2">
              ni2
            </option>
            <option key="4ess" value="4ess">
              4ess
            </option>
            <option key="5ess" value="5ess">
              5ess
            </option>
            <option key="qsig" value="qsig">
              qsig
            </option>
            <option key="euroisdn" value="euroisdn">
              euroisdn
            </option>
            <option key="ntt" value="ntt">
              ntt
            </option>
          </Input>
        </Col>
      </Row>
      <div className="sip-section ">
        <Row className="sip-input ">
          <Col sm={6} md={4}>
            <Label for="name" className="sip-input-label">
              Echo Cancellation
            </Label>
          </Col>
          <Col sm={6} md={5}>
            <Toggle
              value={echoCancellation}
              onToggle={e => {
                setEchoCancellation(!e);
              }}
            />
          </Col>
        </Row>
      </div>
      <div className="sip-section ">
        <Row className="sip-input ">
          <Col sm={6} md={4}>
            <Label for="name" className="sip-input-label">
              Channel Range
            </Label>
          </Col>
          <Col sm={6} md={5}>
            <Input required value={dropDownStates.channelRange} disabled type="text" name="channelRange" />
        </Col>
        </Row>
      </div>
      <Row style={{ paddingTop: '5px', marginBottom: '15px' }}>
        <Col sm={6} md={4}>
          <Label className="sip-input-label">Echo Cancelation Type</Label>
        </Col>
        <Col sm={6} md={5}>
          <Input
            required
            value={dropDownStates.echoCancellationType}
            type="text"
            name="echoCancelationType"
            disabled
          />
        </Col>
      </Row>
      <Row style={{ paddingTop: '5px', marginBottom: '15px' }}>
        <Col sm={6} md={4}>
          <Label className="pri-input-label bold">CAS Failover</Label>
        </Col>
        <Col sm={6} md={5}>
          <Toggle
            value={casToggle}
            onToggle={(e) => onToggleCAS(e)}
          />
        </Col>
      </Row>
      {
        casToggle ?
          <Row style={{ paddingTop: '5px', marginBottom: '15px' }}>
            <Col sm={6} md={4}>
              <Label className="sip-input-label underline">Select Backup CAS</Label>
            </Col>
            <Col sm={6} md={5}>
              <MultiSelectPriDropdown
                MultiSelect
                nameTag="serialNumber"
                filterTag="serialNumber"
                className="testing-filter"
                placeholder={
                  !(casCompaniesList?.length > 0)
                    ? 'No Boxes Found'
                    : 'Select Box Serial Number'
                }
                dropdownList={casCompaniesList}
                showFirstListElement
                onChange={onCasChange}
                initialList={preSelectedCasList}
                sortedData={sortedDataList}
              />
            </Col>
          </Row>
          : null
      }
      {/* <div className="sip-section ">
        <Row className="sip-input ">
          <Col sm={6} md={4}>
            <Label for="name" className="sip-input-label">
              Authentication
            </Label>
          </Col>
          <Col sm={6} md={5}>
            <Input type="select" value={selectedOptions} onChange={handleSelectedOption}>
              {!selectedOptions && (
                <option key="selectType" value="">
                  Select Type
                </option>
              )}
              <option key="ipAuth" value="ipauth">
                IP Auth
              </option>
              <option key="username/password" value="username/password">
                Username/Password
              </option>
            </Input>
          </Col>
        </Row>
      </div>
      {!isAuthenticationIpAuth && selectedOptions === SELECTED_OPTIONS.USERNAME_PASSWORD && (
        <div className="sip-section ">
          <Row className="sip-input ">
            <Col sm={6} md={4}>
              <Label for="name" className="sip-input-label">
                Username:
              </Label>
            </Col>
            <Col sm={6} md={5}>
              <Input
                onChange={e => setUsername(e.target.value)}
                placeholder="Enter Username"
                required
                value={username}
                type="text"
                name="username"
              />
            </Col>
          </Row>
          <Row className="sip-input ">
            <Col sm={6} md={4}>
              <Label for="name" className="sip-input-label">
                Password:
              </Label>
            </Col>
            <Col sm={6} md={5}>
              <Input
                style={{ with: '100%' }}
                onChange={e => setPassword(e.target.value)}
                placeholder="Enter password"
                required
                value={password}
                type="password"
                name="password"
              />
            </Col>
          </Row>
          {IpInfo()}
        </div>
      )}
      {isAuthenticationIpAuth && (
        <div className="sip-section ">
          <Row className="sip-input ">
            <Col sm={6} md={4}>
              <Label for="name" className="sip-input-label">
                IP Address:
              </Label>
            </Col>
            <div className="port-container__ip-auth">
              <Label className="sip-input-label big-font">{SIP_IP_ADDRESS_WITHOUT_ONE}</Label>
              <div className="one-digit-input">
                <Input
                  onChange={handleInputChnage}
                  required
                  value={ipAddress}
                  type="number"
                  name="ipAddress"
                  min="0"
                  max="1000"
                  step="3"
                />
              </div>
            </div>
          </Row>
        </div>
      )} */}
      <Row>
        <Col className="pri-save-btn">
          <Button color="primary" 
          disabled={saveLoading}
          onClick={ () => {
            const divElement = document.getElementById('test-time-remaining');
            const isHidden = divElement.getAttribute('hidden') !== null;
            if (isHidden) {
              setDcUpdatePopup({ show: true });
            } else {
              onSubmit();
            }
          }}>
            {saveLoading ? (
              <span style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
                <span style={{ width: '16px', height: '16px', display: 'inline-flex', alignItems: 'center' }}>
                  <SpinnerCircles red />
                </span>
                <span>Saving...</span>
              </span>
            ) : (
              'Save CAS Detail'
            )}
          </Button>
        </Col>
      </Row>
      <ConfirmationModal
        bodyText="Please reboot this device for changes to take effect."
        isOpen={warningModal}
        onCancel={() => setWarningModal(false)}
        ignoreConfirmButton
        close
      />
      <AddSecurityCodeModal
        isOpen={securityModal}
        onCancel={() => setSecurityModal(false)}
        onConfirm={onSecurityConfirm}
        featureName='casFailover'
      />
    </div>
  );
});

export default EpikboxSip;
